//
import { ModuleLayout } from '@/components/reusable_components/next'
import { UsersCreate, UsersList, UsersShow } from '@/views/users'

//
export default {
    path: 'users',
    component: ModuleLayout,
    children: [
        {
            path: 'create',
            name: 'users_create',
            component: UsersCreate,
            meta: {
                title: 'Crear vendedor'
            }
        },
        {
            path: '',
            name: 'users_list',
            component: UsersList,
        },
        {
            path: ':id',
            name: 'users_show',
            component: UsersShow,
            meta: {
                title: 'Detalles del vendedor'
            }
        },
    ],
    meta: {
        title: 'Vendedores'
    }
}